<script>
    // -- IMPORTS
    
    import { getImagePath } from '$lib/filePath';
    import { getLocalizedText, setLanguageTag } from "senselogic-gist";
    import { languageTagStore } from '$lib/store/languageTagStore';
    import { navigate } from "svelte-routing";
    import page from '$lib/store/pageStore';
    import { slide } from 'svelte/transition';

    // -- VARIABLES

    /** @type {{languageIconPath: any, languageName: any, optionArray: any, isMobileNavigationOpen: any}} */
    let {
        languageIconPath = $bindable(),
        languageName,
        optionArray,
        isMobileNavigationOpen = $bindable()
    } = $props();
    
    let isOpen = $state(false);

    // -- FUNCTIONS

    function setLanguage(
        selectedLanguage
        )
    {
        let languageCode = selectedLanguage.languageCode;

        let languageRoute
            = ( $page.url.pathname + '/' ).replace(
                  '/' + $languageTagStore + '/',
                  '/' + languageCode + '/'
                  ).slice( 0, -1 );

        $languageTagStore = languageCode;
        setLanguageTag( languageCode );

        navigate( languageRoute );

        isMobileNavigationOpen = false;
        isOpen = false;
    }

    // -- FUNCTIONS

    function fadeSlide(
        node, 
        options
        ) 
    {
		let slideTransition = slide(node, options);

		return {
			duration: options.duration,
			css: t => `
                ${ slideTransition.css( t, 1 - t ) }
                opacity: ${ t };
			`
		};
	}
</script>

<style lang="stylus">
    @import '../../../constant.styl'
    @import '../../../mixin.styl'

    button
        font-size: 1rem
        text-decoration: none
        text-transform: uppercase
        color: lightGreyColor
        cursor: pointer
        transition: all 0.1s ease-in-out

        +media(smaller-desktop)
            line-height: 2rem
            font-size: 1.5rem
            letter-spacing: 0.08em

        background-color: unset

    .dropdown-navigation-link
        position: relative
        display: flex
        flex-direction: column
        width: 100%

        +media(smaller-desktop)
            width: 100%
            border-bottom: 1px solid #2A2A2A
            padding: 1rem 0

        .icon.is-active
            transform: rotate(-180deg)

    .main-link
        display: flex
        gap: 1rem
        align-items: center
        justify-content: flex-start
        width: fit-content

        // +media(smaller-desktop)
        //     width: 100%
        //     justify-content: space-between

    .dropdown-menu
        z-index: 100
        margin-top: 1rem
        min-width: 11.875rem
        width: fit-content
        box-shadow: 1px 3px 8px pureBlackColor
        display: flex
        flex-direction: column

        +media(desktop)
            position: absolute
            top: 2rem
            left: 0

    .dropdown-option-container
        width: 100%
        border-bottom: 1px solid #2A2A2A
        padding: .5rem 1.5rem
        margin: 0
        background-color: darkGreyColor
        cursor: pointer

        +media(desktop)
            border-bottom: 1px solid black

        &:last-child
            border-bottom: none

    .dropdown-option
        border-bottom: none
        display: flex
        gap: 0.5rem
        align-items: center
        text-decoration: none
        text-transform: inherit
        color: lightGreyColor
        padding: 0.5rem 0

        &:hover
            color: lightGoldColor

    .icon
        transition: all 0.2s ease

    .flag
        height: 1.5rem
        width: 2rem

</style>

<div class="dropdown-navigation-link">
    <button
        type="button"
        class="main-link"
        onclick={ () => isOpen = !isOpen }
    >
        <div class="dropdown-option">
            <!-- {#if languageIconPath }
               <img class="flag" src={ getImagePath( languageIconPath ) } />
            {/if} -->
            { getLocalizedText( $languageTagStore, $languageTagStore ) }
        </div>
        <div class="down-caret-icon size-100 icon" class:is-active={ isOpen } ></div>
    </button>
    
    {#if isOpen}
        <div class="dropdown-menu" transition:fadeSlide="{{ duration: 150 }}">
            {#each optionArray as option }
                <button
                    class="dropdown-option-container"
                    onclick={
                        () =>
                        {
                                let languageCode = option.languageCode;

                                let languageRoute
                                    = ( $page.url.pathname + '/' ).replace(
                                        '/' + $languageTagStore + '/',
                                        '/' + languageCode + '/'
                                        ).slice( 0, -1 );

                                $languageTagStore = languageCode;
                                setLanguageTag( languageCode );

                                navigate( languageRoute );

                            isMobileNavigationOpen = false;
                            isOpen = false;
                        }
                    }
                >
                    <div
                        class="dropdown-option"
                    >
                        {#if option.labelIcon}
                            <img class="flag" src={ getImagePath( option.languageIconPath ) } />
                        {/if}
                        { getLocalizedText( option.languageName, $languageTagStore ) }
                    </div>
                </button>
            {/each}
        </div>
    { /if }
</div>
